module.exports = __webpack_public_path__ + "img/108-Gris Quartz Stylo.jpg";